import React from "react";

import styles from "./index.module.css";
import Item, { itemSize, xPlacementOffset } from "./item";

const itemStyle = {
  height: itemSize,
  width: itemSize,
  marginLeft: -(itemSize * xPlacementOffset),
};

type Props = {
  rows: string[][];
  animate?: boolean;
};

const List = ({ rows, animate }: Props) => (
  <div className="relative inline-block">
    {rows.map((list, index) => (
      <div
        key={index}
        className={styles.row}
        style={{
          top: -(index * itemSize * 0.4),
          marginLeft: index % 2 !== 0 ? -(itemSize / 2 - (itemSize * xPlacementOffset) / 2) : 0,
        }}
      >
        {list.map(integration => (
          <div key={integration} className="inline-block" style={itemStyle}>
            <Item integration={integration} animate={animate} row={index} />
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default List;
